<p class="prf-description" [style.font-weight]="fontWeight"><ng-content /></p>
